
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"aria-hidden":"true","viewBox":"0 0 45 45","width":"18","height":"18","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.22 27.576l1.6-1.598c2.63 2.837 6.375 4.626 10.539 4.626 7.933 0 14.388-6.455 14.388-14.39 0-4.163-1.788-7.908-4.625-10.538l1.454-1.454.269.268a16.406 16.406 0 014.837 11.677c0 4.41-1.718 8.557-4.837 11.678a16.406 16.406 0 01-11.678 4.835A16.4 16.4 0 019.49 27.845l-.27-.27zM21.36 4.104c6.677 0 12.11 5.433 12.11 12.11 0 6.679-5.433 12.112-12.11 12.112-6.678 0-12.111-5.433-12.111-12.111 0-6.678 5.433-12.111 12.11-12.111zm13.096 25.35a18.665 18.665 0 005.504-13.287c0-5.02-1.954-9.738-5.504-13.288l-1.88-1.88-3.244 3.247a14.304 14.304 0 00-7.972-2.42c-7.934 0-14.39 6.455-14.39 14.389a14.3 14.3 0 002.42 7.97L6 27.576l1.88 1.88c3.424 3.423 7.85 5.225 12.34 5.45v6.943h-6.957a1.138 1.138 0 100 2.279h16.195a1.14 1.14 0 000-2.28h-6.96v-6.96c4.36-.307 8.633-2.106 11.958-5.432z"}})])
          )
        }
      }
    